import React, { FunctionComponent, useEffect, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from '@tanstack/react-query';

import { fetch_one, fetch_all } from '../../lib/server_helper';
import { checkAllowed } from '../../lib/permission';
import { fetchAll, fetchOne } from '../../lib/v31lib';

import { usePDF } from '@react-pdf/renderer';
import { Bar, BarChart, CartesianGrid, Dot, ReferenceArea, ReferenceLine, Scatter, ScatterChart, XAxis, YAxis } from 'recharts';

import NorthEastIcon from '@mui/icons-material/NorthEast';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import SouthEastIcon from '@mui/icons-material/SouthEast';
import SyncAltIcon from '@mui/icons-material/SyncAlt';

import {
  Box,
  Checkbox,
  Divider,
  Grid,
  Paper
} from '@mui/material';

import { Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { TooltipProps } from 'recharts';
import {
  ValueType,
  NameType,
} from 'recharts/types/component/DefaultTooltipContent';

import { loginAtom } from '../../lib/auth';

// import { AlertCheckInputs } from '../../components/alerts/CheckInputs';
// import { AlertSaved } from '../../components/alerts/Saved';
// import { AlertSomethingWentWrong } from '../../components/alerts/SomethingWentWrong';

import {
  Page,
  StyledButton,
  StyledSelect,
  Typography
} from '../../components/interface';

import MyDocument from '../pdf/CustomReportBc';

import { ReportVersion } from '../../models/ReportVersion';
import { AlertEmailSent } from '../../components/alerts/EmailSent';

// const { DateTime } = require("luxon");

// type AvailableLang = 'nl' | 'fr' | 'en';
type Props = {};
type LocDataType = {
  id: number|undefined;
  name: {[k: string]: string};
  user_in_ids: number[];
  user_ex_ids: number[];
  user_in_count: number;
  user_ex_count: number;
  questions: {
    [s:string]: {
      internal: {
        detractors: number;
        promotors: number;
        score: number;
        locations: number;
        user_count: number;
      },
      external: {
        detractors: number;
        promotors: number;
        score: number;
        locations: number;
        user_count: number;
      },
      long_text?: {
        nl?: string;
        en?: string;
      },
      weight: number;
    }
  },
  totals: {
    [s:string]: {
      internal: number;
      external: number;
      locations_in: number;
      locations_ex: number;
    }
  },
  nps_in: {
    detractors: number;
    promotors: number;
    score: number;
    user_count: number;
  },
  nps_ex: {
    detractors: number;
    promotors: number;
    score: number;
    user_count: number;
  }
};

export const AdminReportVersionVisualizer: FunctionComponent<Props> = () => {
  // const navigate = useNavigate();
  // const theme = useTheme();
  const {t} = useTranslation(['translations']);

  const params = useParams();

  const colours = ["rgb(56, 51, 107, 1)", "rgb(66, 135, 245, 1)", "rgb(255, 138, 48, 1)", "rgb(222, 205, 55, 1)", "rgb(135, 68, 73, 1)", "rgb(46, 87, 42, 1)"];
  const totalColour = "rgb(0, 255, 119)";

  const [login, setLogin] = useAtom(loginAtom);
  const [reportVersion, setReportVersion] = useState<ReportVersion>();
  const [loader, setLoader] = useState<boolean>(true);
  const [emailSent, setEmailsent] = useState<boolean>(false);
  const [projectId, setProjectId] = useState<string | undefined>(params.id);
  const [activeLocation, setActiveLocation] = useState<string>('');
  const [totData, setTotData] = useState<LocDataType>();
  const [locData, setLocData] = useState<LocDataType>();
  const [prevTotData, setPrevTotData] = useState<LocDataType>();
  const [prevLocData, setPrevLocData] = useState<LocDataType>();
  const [instance, updateInstance] = usePDF({
    document: (<MyDocument
      locData={locData}
      name={reportVersion?.report_project_company_name}
      logo={reportVersion?.report_project_get_menu_logo}
    />),
  });
  const [includePrev, setIncludePrev] = useState<boolean>(false);

  const fetchCalculation = () => {
    if (login?.is_organiser || checkAllowed(login, null, null, "ProjectExport", 'r', true)) {
      setLoader(true);
      
      fetch_one<ReportVersion>('/nl/v3/objects/fetch_all', {
        object: 'report_version',
        fields: ['id', 'extra_data', 'name', 'report|id/is_simplified', 'report|project|id/get_menu_logo', 'report|project|company|id/name', 'report'],
        sub_fields: {
          report: ['id', 'project'],
          project: ['id', 'memoq_setting_id']
        },
        id: projectId
      }, (ob) => {
        setReportVersion(ob);
        setLoader(false);
      }, () => {
        // setServerErrorSnackOpen(true);
      }, (!!login?.auth_token ? {auth_token: login?.auth_token, email: login?.email} : undefined));
    } else {
      setLoader(false);
    }
  };

  const {
    data: locations,
    isLoading: locationsLoading,
    // isError: bookYearsError,
    // isSuccess: bookYearsSuccess,
    refetch: locationsRefetch,
  } = useQuery({
    queryKey: ["memoq_locations", reportVersion?.report?.project?.memoq_setting_id],
    queryFn: () =>
      fetchAll<Location>(
        "/nl/v3/objects/fetch_all",
        {
          object: "location",
          fields: [
            "id", 'name', 'current_nof_children'
          ],
          // sub_fields: {
          //   'company': ['id', 'name', 'get_item'],
          //   'user': ['id', 'first_name', 'last_name']
          // },
          order: "id ASC",
          page: 0,
          per_page: 200,
          filter: {
            search: '',
            advanced: {
              memoq_setting_id: reportVersion?.report?.project?.memoq_setting_id
            }
          }
        },
        login
      ),
    enabled: !!login && !!reportVersion?.report?.project?.memoq_setting_id
  });








  

  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetchOne<any>(
        "/nl/v3/objects/custom_action",
        pars.formData,
        login
      );
    },
    onSuccess: (data, variables, context) => {
      setEmailsent(true);
    },
  });






  

  useEffect(() => {
    fetchCalculation();
  }, []);
  useEffect(() => {
    let dimension = Object.values((reportVersion?.extra_data?.results?.dimensions || {})).filter(fff => (fff.id?.toString() || '0') === activeLocation)[0];

    if (!!dimension) {
      console.log(dimension);
      setLocData(dimension);
      setTotData(Object.values((reportVersion?.extra_data?.results?.dimensions || {})).filter(fff => !fff.id)[0]);
      setPrevLocData(prevDimension(dimension.id || 0));
      setPrevTotData(Object.values((reportVersion?.extra_data?.prev_results?.dimensions || {})).filter(fff => !fff.id)[0]);
    }
  }, [activeLocation]);
  useEffect( () => {
    // console.log(locData);
    // console.log(reportVersion?.report_project_company_name);
    updateInstance(<MyDocument
      locData={locData}
      totData={totData}
      allData={reportVersion}
      name={reportVersion?.report_project_company_name}
      logo={reportVersion?.report_project_get_menu_logo}
    />)
  }, [locData]);

  const CustomTooltip = ({
    active,
    payload,
    label,
}: TooltipProps<ValueType, NameType>) => {
    if (active) {
      return (
        <Paper sx={{padding: 2}}>
          {!(((payload || [])[0] || {})['payload'] || {}).full_name && <Typography sx={{fontWeight: 'bold'}}>{(((payload || [])[0] || {})['payload'] || {})['name']}</Typography>}
          {!!(((payload || [])[0] || {})['payload'] || {}).full_name && <Typography sx={{fontWeight: 'bold'}}>{(((payload || [])[0] || {})['payload'] || {}).full_name}</Typography>}
          {!!(((payload || [])[0] || {})['payload'] || {}).location && <Typography sx={{fontWeight: 'bold'}}>{(((payload || [])[0] || {})['payload'] || {}).location}</Typography>}
          {!!((payload || [])[0] || {}).payload?.totalInternal && <>
            <Typography>External: {((payload || [])[0] || {}).payload.external}</Typography>
            <Typography>Internal: {((payload || [])[0] || {}).payload.internal}</Typography>
            <Divider sx={{marginTop: 1, marginBottom: 1}} />
            <Typography>External (total): {((payload || [])[0] || {}).payload.totalExternal}</Typography>
            <Typography>Internal (total): {((payload || [])[0] || {}).payload.totalInternal}</Typography>
          </>}
          {!((payload || [])[0] || {}).payload?.totalInternal && (payload || []).map(mm => <Typography sx={{textTransform: 'capitalize'}}>{mm.name}: {mm.value}</Typography>)}
        </Paper>
      );
    }

    return null;
};

const statBlock = (icon: string, title: string, stat: any, bordercolor: string, backcolor: string, extra_line?: any, uneven?: boolean) => {
  return <Box sx={{
    padding: 1,
    border: `1px solid ${bordercolor}`,
    borderRadius: 1,
    backgroundColor: backcolor
  }}>
    <Box sx={{
      display: 'inline-block',
      width: !!uneven ? '30%' : '50%',
      height: '100%',
      // borderRight: '2px solid #2b4699',
      // padding: 1
    }}>
      <Box sx={{
        borderRight: `2px solid ${bordercolor}`,
        padding: 1,
        textAlign: 'center'
      }}>
        {icon === 'invites' && <PersonSearchIcon sx={{color: 'white', width: '60px', height: '60px'}} />}
        {icon === 'answers' && <QuestionAnswerIcon sx={{color: 'white', width: '60px', height: '60px'}} />}
        {icon === 'period' && <QueryBuilderIcon sx={{color: 'white', width: '60px', height: '60px'}} />}
      </Box>
    </Box>
    <Box sx={{
      display: 'inline-block',
      width: !!uneven ? '70%' : '50%',
      height: '100%',
      // padding: 1
    }}>
      <Box sx={{
        padding: 1
      }}>
        <Typography sx={{
          color: 'white',
          fontSize: '0.7rem',
          textAlign: 'center'
        }}>{title}</Typography>
        <Typography sx={{
          color: 'white',
          fontSize: '3rem',
          textAlign: 'center'
        }}>{stat}</Typography>
        {!!extra_line && extra_line}
      </Box>
    </Box>
  </Box>;
}

const prevDimension = (dimensionId: number) => {
  return (Object.values((reportVersion?.extra_data?.prev_results?.dimensions || {})).filter(fff => (!!dimensionId ? fff.id === dimensionId : !fff.id)) || [])[0];
}

const comparePrev = (vPrev: number, vNow: number, toFixed?: boolean) => {
  return <>
    {!includePrev && <Typography>{!!toFixed ? vNow.toFixed(2) : vNow}</Typography>}
    {!!includePrev && <Typography>{!!toFixed ? vPrev.toFixed(2) : vPrev}&nbsp;{vPrev > vNow && <SouthEastIcon sx={{color: 'red', width: '14px', height: '14px', marginBottom: '-2px'}} />}{vPrev < vNow && <NorthEastIcon sx={{color: 'green', width: '14px', height: '14px', marginBottom: '-2px'}} />}{vPrev === vNow && <SyncAltIcon sx={{color: 'grey', width: '14px', height: '14px', marginBottom: '-2px'}} />}&nbsp;{!!toFixed ? vNow.toFixed(2) : vNow}</Typography>}
  </>
}

  return (
    <Page sx={{}} title={t("objects.report_version.visualizer.title")}>
      <Grid container spacing="8">
        {/* <Grid item xs={12}>
          {!!reportVersion?.extra_data?.results && JSON.stringify(reportVersion?.extra_data?.results)}
        </Grid> */}

        <Grid item xs={6}>
          <StyledSelect
            label="Location"
            value={activeLocation}
            id='location'
            onChange={(v) => {
              setActiveLocation(v);
              console.log(v);
            }}
            list={[
              {id: '', name: "--- ---"},
              ...(Object.values((reportVersion?.extra_data?.results?.dimensions || {})).map(dimension => {return {id: dimension.id?.toString() || '0', name: dimension.name.en || ''}}))
            ]}
          />
        </Grid>

        {/* {!locData && <Grid item xs={6}></Grid>} */}
        {true && <Grid item xs={6}>
          {/* <StyledButton
            label="Download report"
            id="download"
            onClick={() => {
              ReactDOM.render(<PDFViewer><MyDocument /></PDFViewer>, document.getElementById('root'));
            }}
          /> */}
          {/* <PDFDownloadLink document={<MyDocument
            locData={locData}
          />} fileName="report.pdf">
            {/* @ts-ignore *}
            {({ loading }) => loading ? 'Loading document...' : 'Download now!'}
          </PDFDownloadLink> */}

          {!!locData && !reportVersion?.report_is_simplified && <StyledButton
            label="Send comment export"
            id="send_comment_export"
            loading={mutationCustomAction.isPending}
            contained
            sx={{
              marginTop: 1,
              marginLeft: 1,
              marginRight: 1
            }}
            onClick={() => {
              mutationCustomAction.mutate({
                formData: {
                  object: 'report_version',
                  class_action: 'custom_api_send_memoq_comments',
                  id: projectId,
                  location: activeLocation
                }
              });
            }}
          />}

          {!reportVersion?.report_is_simplified && <StyledButton
            label="Send excel export (charts)"
            id="send_excel_export"
            loading={mutationCustomAction.isPending}
            contained
            sx={{
              marginTop: 1,
              marginLeft: 1,
              marginRight: 1
            }}
            onClick={() => {
              mutationCustomAction.mutate({
                formData: {
                  object: 'report_version',
                  class_action: 'custom_api_send_excel_charts',
                  id: projectId,
                  location: activeLocation
                }
              });
            }}
          />}

          {!!locData && !reportVersion?.report_is_simplified && !!instance.url && <a href={instance.url} download="report.pdf">Download</a>}
        </Grid>}

        <Grid item xs={3}>
          {statBlock(!!loader ? 'loading' : 'invites', 'Invites', !loader ? reportVersion?.extra_data?.stats?.total_invites : '&nbsp;', '#2b4699', '#4e76ed')}
        </Grid>
        <Grid item xs={3}>
          {statBlock(!!loader ? 'loading' : 'answers', 'Answers', !loader ? reportVersion?.extra_data?.stats?.total_partakes : '&nbsp;', '#3c5e3b', '#76b374')}
        </Grid>
        <Grid item xs={6}>
          {statBlock(!!loader ? 'loading' : 'period', 'Period', !loader ? reportVersion?.extra_data?.stats?.iteration_name : '&nbsp;', '#1e3857', '#507eb5', undefined, true)}
        </Grid>
        {!!activeLocation && !reportVersion?.report_is_simplified && !!reportVersion?.extra_data?.prev_results && <Grid item xs={12}>
          <Checkbox sx={{display: 'inline-block', padding: '4px'}} checked={includePrev} onChange={(v) => {
            setIncludePrev(!includePrev);
          }} />
          <Typography sx={{display: 'inline-block', marginLeft: 1}}>{t("memoq.stats.include_previous_iteration", "Include previous iteration")}</Typography>
        </Grid>}
        <Grid item xs={12}>
          &nbsp;
        </Grid>

        {!!reportVersion?.extra_data?.results?.dimensions && Object.values(reportVersion?.extra_data?.results.dimensions).map(dimension => <>
          {!!dimension.id && dimension.id.toString() === activeLocation && <>
            <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              <Typography>{dimension.name.en}</Typography>
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              <Typography>Ouders</Typography>
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              <Typography>Personeel</Typography>
            </Grid>
            {/* <Grid item xs={2} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              <Typography>Gewicht</Typography>
            </Grid> */}

            <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              <Typography>Deelnemers</Typography>
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              {comparePrev(prevDimension(dimension.id)?.user_ex_count, dimension.user_ex_count)}
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              {comparePrev(prevDimension(dimension.id)?.user_in_count, dimension.user_in_count)}
            </Grid>
            {/* <Grid item xs={2} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              
            </Grid> */}

            {[
              ['q11', 'q12', 'q13'],
              ['q21', 'q22', 'q23'],
              ['q31', 'q32', 'q33', 'q34'],
              ['q41', 'q42'],
              ['q51', 'q52', 'q53'],
              ['q61', 'q62', 'q63']
            ].map((dim_questions, i) => {
              return (<>
                {dim_questions.map(q => <>
                  <Grid item xs={6}>
                    <Typography>{dimension.questions[q]?.long_text?.nl?.replace(/<[^>]*>?/gm, '').substr(0, 60) || q.toUpperCase()}</Typography>
                  </Grid>
                  <Grid item xs={3}>
                    {comparePrev(((prevDimension(dimension.id || 0)?.questions || [])[q] || {}).external?.score, dimension.questions[q].external?.score)}
                  </Grid>
                  <Grid item xs={3}>
                    {comparePrev(((prevDimension(dimension.id || 0)?.questions || [])[q] || {}).internal?.score, dimension.questions[q].internal?.score)}
                  </Grid>
                  {/* <Grid item xs={2}>
                    <Typography>{dimension.questions[q].weight}%</Typography>
                  </Grid> */}
                </>)}
                <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.08)'}}>
                  {/* @ts-ignore */}
                  <Typography>{((reportVersion.extra_data || {})[`dimension${i + 1}`] || {})['nl']}</Typography>
                </Grid>
                <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.08)'}}>
                  {comparePrev(((prevDimension(dimension.id || 0)?.totals || {})[`dim${i + 1}`] || {}).external, dimension.totals[`dim${i + 1}`].external)}
                </Grid>
                <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.08)'}}>
                  {comparePrev(((prevDimension(dimension.id || 0)?.totals || {})[`dim${i + 1}`] || {}).internal, dimension.totals[`dim${i + 1}`].internal)}
                </Grid>
                {/* <Grid item xs={2} sx={{backgroundColor: 'rgba(0, 0, 0, 0.08)'}}></Grid> */}
              </>);
            })}

            {/* <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              <Typography>NPS</Typography>
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              <Typography>{dimension.nps_ex.score * 100} ({dimension.nps_ex.detractors} + {(dimension.user_ex_count - (dimension.nps_ex.detractors + dimension.nps_ex.promotors))} + {dimension.nps_ex.promotors})</Typography>
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              <Typography>{dimension.nps_in.score * 100} ({dimension.nps_in.detractors} + {(dimension.user_in_count - (dimension.nps_in.detractors + dimension.nps_in.promotors))} + {dimension.nps_in.promotors})</Typography>
            </Grid> */}

            <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              <Typography>NPS</Typography>
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              {comparePrev(prevDimension(dimension.id || 0)?.nps_ex.score * 100, dimension.nps_ex.score * 100)}
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              {comparePrev(prevDimension(dimension.id || 0)?.nps_in.score * 100, dimension.nps_in.score * 100)}
            </Grid>
            <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              <Typography>NPS Detractors</Typography>
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              {comparePrev(prevDimension(dimension.id || 0)?.nps_ex.detractors, dimension.nps_ex.detractors)}
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              {comparePrev(prevDimension(dimension.id || 0)?.nps_in.detractors, dimension.nps_in.detractors)}
            </Grid>
            <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              <Typography>NPS Neutrals</Typography>
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              {comparePrev((prevDimension(dimension.id || 0)?.user_ex_count - (prevDimension(dimension.id || 0)?.nps_ex.detractors + prevDimension(dimension.id || 0)?.nps_ex.promotors)), (dimension.user_ex_count - (dimension.nps_ex.detractors + dimension.nps_ex.promotors)))}
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              {comparePrev((prevDimension(dimension.id || 0)?.user_in_count - (prevDimension(dimension.id || 0)?.nps_in.detractors + prevDimension(dimension.id || 0)?.nps_in.promotors)), (dimension.user_in_count - (dimension.nps_in.detractors + dimension.nps_in.promotors)))}
            </Grid>
            <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              <Typography>NPS Promotors</Typography>
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              {comparePrev(prevDimension(dimension.id || 0)?.nps_ex.promotors, dimension.nps_ex.promotors)}
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              {comparePrev(prevDimension(dimension.id || 0)?.nps_in.promotors, dimension.nps_in.promotors)}
            </Grid>
            {/* <Grid item xs={2} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              
            </Grid> */}

            <Grid item xs={12}>&nbsp;</Grid>



            
            {!reportVersion?.report_is_simplified && !!locData && ['dim1', 'dim2', 'dim3', 'dim4', 'dim5', 'dim6'].map((dimKey, i) => <Grid item xs={4}>
              {/* @ts-ignore */}
              <Typography sx={{textAlign: 'center'}}>{((reportVersion.extra_data || {})[`dimension${i + 1}`] || {})['nl']}</Typography>
              {!!locData.totals[dimKey] && <ResponsiveContainer width="100%" height={!!prevLocData && !!includePrev ? 400 : 200}>
                <BarChart data={[
                  {
                    name: "Pers.",
                    score: [0, locData.totals[dimKey].internal],
                  },
                  {
                    name: "Ouders",
                    score: [0, locData.totals[dimKey].external]
                  },
                  {
                    name: "T Pers.",
                    score: [0, !!totData ? (totData.totals[dimKey].internal / totData.totals[dimKey].locations_in) : 0],
                  },
                  {
                    name: "T Oud.",
                    score: [0, totData ? (totData.totals[dimKey].external / totData.totals[dimKey].locations_ex) : 0]
                  },
                  ...(!!prevLocData && !!includePrev ? [{
                    name: "PrevPers.",
                    score: [0, prevLocData.totals[dimKey].internal],
                  },
                  {
                    name: "PrevOud.",
                    score: [0, prevLocData.totals[dimKey].external]
                  },
                  {
                    name: "PT Pers.",
                    score: [0, !!prevTotData ? (prevTotData.totals[dimKey].internal / prevTotData.totals[dimKey].locations_in) : 0],
                  },
                  {
                    name: "PT Oud.",
                    score: [0, prevTotData ? (prevTotData.totals[dimKey].external / prevTotData.totals[dimKey].locations_ex) : 0]
                  }] : [])
                ]} layout="vertical" margin={{
                  top: 20,
                  right: 20,
                  bottom: 20,
                  left: 20
                }}>
                  <XAxis type="number" domain={[0, 5]} ticks={[0, 1, 2, 3, 4, 5]} />
                  <YAxis dataKey="name" type="category" />
                  <Bar dataKey="score">
                    {[
                      {
                        name: "Pers.",
                        score: [0, locData.totals[dimKey].internal],
                      },
                      {
                        name: "Ouders",
                        score: [0, locData.totals[dimKey].external]
                      },
                      {
                        name: "T Pers.",
                        score: [0, !!totData ? (totData.totals[dimKey].internal / totData.totals[dimKey].locations_in) : 0],
                      },
                      {
                        name: "T Oud.",
                        score: [0, totData ? (totData.totals[dimKey].external / totData.totals[dimKey].locations_ex) : 0]
                      },
                      ...(!!prevLocData && !!includePrev ? [{
                        name: "PrevPers.",
                        score: [0, prevLocData.totals[dimKey].internal],
                      },
                      {
                        name: "PrevOud.",
                        score: [0, prevLocData.totals[dimKey].external]
                      },
                      {
                        name: "PT Pers.",
                        score: [0, !!prevTotData ? (prevTotData.totals[dimKey].internal / prevTotData.totals[dimKey].locations_in) : 0],
                      },
                      {
                        name: "PT Oud.",
                        score: [0, prevTotData ? (prevTotData.totals[dimKey].external / prevTotData.totals[dimKey].locations_ex) : 0]
                      }] : [])
                    ].map(bar => <Cell fill={bar.name.substr(0, 2) === "PT" ? (bar.score[1] > 2.5 ? '#013007' : '#521510') : (bar.name.substr(0, 4) === "Prev" ? (bar.score[1] > 2.5 ? '#024d0b' : '#6e1c16') : (bar.name[0] === "T" ? (bar.score[1] > 2.5 ? '#046910' : '#8c251d') : (bar.score[1] > 2.5 ? '#089c19' : '#eb4034')))} />)}
                  </Bar>
                  <CartesianGrid strokeDasharray="3 3" />
                </BarChart>
              </ResponsiveContainer>}
            </Grid>)}

            <Grid item xs={12}>&nbsp;</Grid>



            
            {!reportVersion?.report_is_simplified && !!locData && !!prevLocData && !!includePrev && <Grid item xs={12}>
              <Typography sx={{
                fontSize: '0.9rem',
                fontStyle: 'italic',
                color: 'lightgrey',
                textAlign: 'center'
              }}>The Scatterchart will not include previous totals or previous location data.</Typography>
            </Grid>}
            {!reportVersion?.report_is_simplified && !!locData && <Grid item xs={12}>
              <ResponsiveContainer width="100%" height={600}>
                <ScatterChart
                  margin={{
                    top: 20,
                    right: 20,
                    bottom: 20,
                    left: 20
                  }}
                >
                  <CartesianGrid />
                  <ReferenceArea x1={0} x2={2.5} y1={2.5} y2={0} fill="red" fillOpacity={0.3} />
                  <ReferenceArea x1={2.5} x2={5} y1={2.5} y2={5} fill="green" fillOpacity={0.3} />
                  <ReferenceArea x1={0} x2={2.5} y1={5} y2={2.5} fill="orange" fillOpacity={0.2} />
                  <ReferenceArea x1={2.5} x2={5} y1={2.5} y2={0} fill="orange" fillOpacity={0.2} />

                  <XAxis type="number" dataKey="external" label="&nbsp;     &nbsp;      &nbsp;     &nbsp;       &nbsp;   &nbsp;       &nbsp;      &nbsp;      &nbsp;      &nbsp;      Ouders" domain={[0, 5]} ticks={[0, 2.5, 5]} />
                  <YAxis type="number" dataKey="internal" label="Pers.  &nbsp; &nbsp;   &nbsp; &nbsp;   &nbsp;" domain={[0, 5]} ticks={[0, 2.5, 5]} />
                  <Tooltip content={<CustomTooltip />} />

                  <Scatter data={['dim1', 'dim2', 'dim3', 'dim4', 'dim5', 'dim6'].map((dimKey, i) => {return !!locData.totals[dimKey] ? {
                    // @ts-ignore
                    name: ((reportVersion.extra_data || {})[`dimension${i + 1}`] || {})['nl'],
                    internal: locData.totals[dimKey].internal,
                    external: locData.totals[dimKey].external,
                    totalInternal: !!totData ? Number((totData.totals[dimKey].internal / totData.totals[dimKey].locations_in).toFixed(2)) : undefined,
                    totalExternal: !!totData ? Number((totData.totals[dimKey].external / totData.totals[dimKey].locations_ex).toFixed(2)) : undefined
                  } : {name: '', internal: '', external: ''};})} fill="#8884d8" shape={(props:any) => {
                    const {cx, cy, fill, name} = props;
                    return (
                      <g>
                        <Dot cx={cx} cy={cy} r={5} fill={fill} />
                        <g transform={`translate(${cx},${cy})`}>
                          <text x={10} y={0} dy={4} textAnchor="left">{name}</text>
                        </g>
                      </g>
                     );
                  }} />
                  {!!totData && <Scatter data={['dim1', 'dim2', 'dim3', 'dim4', 'dim5', 'dim6'].map((dimKey, i) => {return !!totData.totals[dimKey] ? {
                    // @ts-ignore
                    name: `${((reportVersion.extra_data || {})[`dimension${i + 1}`] || {})['nl']} (total)`,
                    // @ts-ignore
                    short_name: ((reportVersion.extra_data || {})[`dimension${i + 1}`] || {})['nl'][0],
                    internal: Number((totData.totals[dimKey].internal / totData.totals[dimKey].locations_in).toFixed(2)),
                    external: Number((totData.totals[dimKey].external / totData.totals[dimKey].locations_ex).toFixed(2))
                  } : {name: '', short_name: '', internal: '', external: ''};})} fill="#64686e" shape={(props:any) => {
                    const {cx, cy, fill, name, short_name} = props;
                    return (
                      <g style={{opacity: 0.7}}>
                        <Dot cx={cx} cy={cy} r={5} fill={fill} />
                        <g transform={`translate(${cx},${cy})`}>
                          <text x={6} y={1} dy={4} textAnchor="left">{short_name}</text>
                        </g>
                      </g>
                     );
                  }} />}

                  <ReferenceLine y={0} stroke="#000000" />
                  <ReferenceLine x={0} stroke="#000000" />
                </ScatterChart>
              </ResponsiveContainer>
            </Grid>}
          </>}






















          {!dimension.id && '0' === activeLocation && <>
            <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              <Typography>{dimension.name.en}</Typography>
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              <Typography>Ouders</Typography>
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              <Typography>Personeel</Typography>
            </Grid>
            {/* <Grid item xs={2} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              <Typography>Gewicht</Typography>
            </Grid> */}

            <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              <Typography>Deelnemers</Typography>
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              {comparePrev(prevDimension(dimension.id || 0)?.user_ex_count, dimension.user_ex_count)}
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              {comparePrev(prevDimension(dimension.id || 0)?.user_in_count, dimension.user_in_count)}
            </Grid>
            {/* <Grid item xs={2} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              
            </Grid> */}
            <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              <Typography>Locaties</Typography>
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              {comparePrev(prevDimension(dimension.id || 0)?.totals.dim1.locations_ex, dimension.totals.dim1.locations_ex)}
            </Grid>
            <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              {comparePrev(prevDimension(dimension.id || 0)?.totals.dim1.locations_in, dimension.totals.dim1.locations_in)}
            </Grid>

            {[
              ['q11', 'q12', 'q13'],
              ['q21', 'q22', 'q23'],
              ['q31', 'q32', 'q33', 'q34'],
              ['q41', 'q42'],
              ['q51', 'q52', 'q53'],
              ['q61', 'q62', 'q63']
            ].map((dim_questions, i) => {
              return (<>
                {dim_questions.map(q => <>
                  <Grid item xs={6}>
                    <Typography>{dimension.questions[q]?.long_text?.nl?.replace(/<[^>]*>?/gm, '').substr(0, 60) || q.toUpperCase()}</Typography>
                  </Grid>
                  <Grid item xs={3}>
                    {/* <Typography>{(dimension.questions[q].external.score / dimension.questions[q].external.locations).toFixed(2)}</Typography> */}
                    {comparePrev((((prevDimension(dimension.id || 0)?.questions || [])[q] || {})?.external?.score / ((prevDimension(dimension.id || 0)?.questions || [])[q] || {})?.external?.locations), (dimension.questions[q].external?.score / dimension.questions[q].external?.locations), true)}
                  </Grid>
                  <Grid item xs={3}>
                    {/* <Typography>{(dimension.questions[q].internal.score / dimension.questions[q].internal.locations).toFixed(2)}</Typography> */}
                    {comparePrev((((prevDimension(dimension.id || 0)?.questions || [])[q] || {})?.internal?.score / ((prevDimension(dimension.id || 0)?.questions || [])[q] || {})?.internal?.locations), (dimension.questions[q].internal?.score / dimension.questions[q].internal?.locations), true)}
                  </Grid>
                  {/* <Grid item xs={2}>
                    <Typography>{dimension.questions[q].weight}%</Typography>
                  </Grid> */}
                </>)}
                <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.08)'}}>
                  {/* @ts-ignore */}
                  <Typography>{((reportVersion.extra_data || {})[`dimension${i + 1}`] || {})['nl']}</Typography>
                </Grid>
                <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.08)'}}>
                  {/* <Typography>{(dimension.totals[`dim${i + 1}`].external / dimension.totals[`dim${i + 1}`].locations_ex).toFixed(2)}</Typography> */}
                  {comparePrev((prevDimension(dimension.id || 0)?.totals[`dim${i + 1}`].external / prevDimension(dimension.id || 0)?.totals[`dim${i + 1}`].locations_ex), (dimension.totals[`dim${i + 1}`].external / dimension.totals[`dim${i + 1}`].locations_ex), true)}
                </Grid>
                <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.08)'}}>
                  {/* <Typography>{(dimension.totals[`dim${i + 1}`].internal / dimension.totals[`dim${i + 1}`].locations_in).toFixed(2)}</Typography> */}
                  {comparePrev((prevDimension(dimension.id || 0)?.totals[`dim${i + 1}`].internal / prevDimension(dimension.id || 0)?.totals[`dim${i + 1}`].locations_in), (dimension.totals[`dim${i + 1}`].internal / dimension.totals[`dim${i + 1}`].locations_in), true)}
                </Grid>
                {/* <Grid item xs={2} sx={{backgroundColor: 'rgba(0, 0, 0, 0.08)'}}></Grid> */}
              </>);
            })}

            {!includePrev && <>
              <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                <Typography>NPS (total)</Typography>
              </Grid>
              <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                <Typography>{Math.round(dimension.nps_ex.score * 100)} ({dimension.nps_ex.detractors} + {(dimension.nps_ex.user_count - (dimension.nps_ex.detractors + dimension.nps_ex.promotors))} + {dimension.nps_ex.promotors})</Typography>
              </Grid>
              <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                <Typography>{Math.round(dimension.nps_in.score * 100)} ({dimension.nps_in.detractors} + {(dimension.nps_in.user_count - (dimension.nps_in.detractors + dimension.nps_in.promotors))} + {dimension.nps_in.promotors})</Typography>
              </Grid>
            </>}

            {!!includePrev && <>
              <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)', borderTop: '5px solid white'}}>
                <Typography>NPS (total)</Typography>
              </Grid>
              <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)', borderTop: '5px solid white'}}>
                {comparePrev(prevDimension(dimension.id || 0)?.nps_ex.score * 100, dimension.nps_ex.score * 100)}
              </Grid>
              <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)', borderTop: '5px solid white'}}>
                {comparePrev(prevDimension(dimension.id || 0)?.nps_in.score * 100, dimension.nps_in.score * 100)}
              </Grid>
              <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                <Typography>&nbsp;&nbsp;&nbsp;NPS Detractors</Typography>
              </Grid>
              <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                {comparePrev(prevDimension(dimension.id || 0)?.nps_ex.detractors, dimension.nps_ex.detractors)}
              </Grid>
              <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                {comparePrev(prevDimension(dimension.id || 0)?.nps_in.detractors, dimension.nps_in.detractors)}
              </Grid>
              <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                <Typography>&nbsp;&nbsp;&nbsp;NPS Neutrals</Typography>
              </Grid>
              <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                {comparePrev((prevDimension(dimension.id || 0)?.user_ex_count - (prevDimension(dimension.id || 0)?.nps_ex.detractors + prevDimension(dimension.id || 0)?.nps_ex.promotors)), (dimension.user_ex_count - (dimension.nps_ex.detractors + dimension.nps_ex.promotors)))}
              </Grid>
              <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                {comparePrev((prevDimension(dimension.id || 0)?.user_in_count - (prevDimension(dimension.id || 0)?.nps_in.detractors + prevDimension(dimension.id || 0)?.nps_in.promotors)), (dimension.user_in_count - (dimension.nps_in.detractors + dimension.nps_in.promotors)))}
              </Grid>
              <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                <Typography>&nbsp;&nbsp;&nbsp;NPS Promotors</Typography>
              </Grid>
              <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                {comparePrev(prevDimension(dimension.id || 0)?.nps_ex.promotors, dimension.nps_ex.promotors)}
              </Grid>
              <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                {comparePrev(prevDimension(dimension.id || 0)?.nps_in.promotors, dimension.nps_in.promotors)}
              </Grid>
            </>}
            {/* <Grid item xs={2} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
              
            </Grid> */}

            {(Object.values((reportVersion?.extra_data?.results?.dimensions || {})).map((dimension, i) => <>{(dimension.name.en || '') !== "Total" && <>
              {!includePrev && <>
                <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                  <Typography>NPS ({dimension.name.en})</Typography>
                </Grid>
                <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                  <Typography>{dimension.nps_ex.score * 100} ({dimension.nps_ex.detractors} + {(dimension.user_ex_count - (dimension.nps_ex.detractors + dimension.nps_ex.promotors))} + {dimension.nps_ex.promotors})</Typography>
                </Grid>
                <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                  <Typography>{dimension.nps_in.score * 100} ({dimension.nps_in.detractors} + {(dimension.user_in_count - (dimension.nps_in.detractors + dimension.nps_in.promotors))} + {dimension.nps_in.promotors})</Typography>
                </Grid>
              </>}

              {!!includePrev && <>
                <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)', borderTop: '5px solid white'}}>
                  <Typography>NPS ({dimension.name.en})</Typography>
                </Grid>
                <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)', borderTop: '5px solid white'}}>
                  {comparePrev(prevDimension(dimension.id || 0)?.nps_ex.score * 100, dimension.nps_ex.score * 100)}
                </Grid>
                <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)', borderTop: '5px solid white'}}>
                  {comparePrev(prevDimension(dimension.id || 0)?.nps_in.score * 100, dimension.nps_in.score * 100)}
                </Grid>
                <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                  <Typography>&nbsp;&nbsp;&nbsp;NPS Detractors</Typography>
                </Grid>
                <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                  {comparePrev(prevDimension(dimension.id || 0)?.nps_ex.detractors, dimension.nps_ex.detractors)}
                </Grid>
                <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                  {comparePrev(prevDimension(dimension.id || 0)?.nps_in.detractors, dimension.nps_in.detractors)}
                </Grid>
                <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                  <Typography>&nbsp;&nbsp;&nbsp;NPS Neutrals</Typography>
                </Grid>
                <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                  {comparePrev((prevDimension(dimension.id || 0)?.user_ex_count - (prevDimension(dimension.id || 0)?.nps_ex.detractors + prevDimension(dimension.id || 0)?.nps_ex.promotors)), (dimension.user_ex_count - (dimension.nps_ex.detractors + dimension.nps_ex.promotors)))}
                </Grid>
                <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                  {comparePrev((prevDimension(dimension.id || 0)?.user_in_count - (prevDimension(dimension.id || 0)?.nps_in.detractors + prevDimension(dimension.id || 0)?.nps_in.promotors)), (dimension.user_in_count - (dimension.nps_in.detractors + dimension.nps_in.promotors)))}
                </Grid>
                <Grid item xs={6} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                  <Typography>&nbsp;&nbsp;&nbsp;NPS Promotors</Typography>
                </Grid>
                <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                  {comparePrev(prevDimension(dimension.id || 0)?.nps_ex.promotors, dimension.nps_ex.promotors)}
                </Grid>
                <Grid item xs={3} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                  {comparePrev(prevDimension(dimension.id || 0)?.nps_in.promotors, dimension.nps_in.promotors)}
                </Grid>
              </>}
              {/* <Grid item xs={2} sx={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}>
                
              </Grid> */}
            </>}</>))}

            <Grid item xs={12}>&nbsp;</Grid>



                        
            {!reportVersion?.report_is_simplified && !!locData && ['dim1', 'dim2', 'dim3', 'dim4', 'dim5', 'dim6'].map((dimKey, i) => <Grid item xs={4}>
              {/* @ts-ignore */}
              <Typography sx={{textAlign: 'center'}}>{((reportVersion.extra_data || {})[`dimension${i + 1}`] || {})['nl']}</Typography>
              {!!locData.totals[dimKey] && <ResponsiveContainer width="100%" height={300}>
                <BarChart data={[
                  {
                    name: "Pers.",
                    score: [0, parseFloat((locData.totals[dimKey].internal / locData.totals[dimKey].locations_in).toFixed(2))],
                    ...(!!prevLocData && !!prevLocData.totals[dimKey] && !!includePrev ? {
                      prevScore: [0, parseFloat((prevLocData.totals[dimKey].internal / prevLocData.totals[dimKey].locations_in).toFixed(2))],
                    } : {}),
                    ...(Object.values((reportVersion?.extra_data?.results?.dimensions || {})).map(dimension => {return {[dimension.name.en || '']: [0, dimension.totals[dimKey].internal]};}).filter(fff => Object.keys(fff)[0] !== "Total") || []).reduce((prev, curr) => {
                      return {
                          ...prev,
                          ...curr
                      };
                    })
                  },
                  {
                    name: "Ouders",
                    score: [0, parseFloat((locData.totals[dimKey].external / locData.totals[dimKey].locations_ex).toFixed(2))],
                    ...(!!prevLocData && !!prevLocData.totals[dimKey] && !!includePrev ? {
                      prevScore: [0, parseFloat((prevLocData.totals[dimKey].external / prevLocData.totals[dimKey].locations_ex).toFixed(2))],
                    } : {}),
                    ...(Object.values((reportVersion?.extra_data?.results?.dimensions || {})).map(dimension => {return {[dimension.name.en || '']: [0, dimension.totals[dimKey].external]};}).filter(fff => Object.keys(fff)[0] !== "Total") || []).reduce((prev, curr) => {
                      return {
                          ...prev,
                          ...curr
                      };
                    })
                  }
                ]} layout="vertical" margin={{
                  top: 20,
                  right: 20,
                  bottom: 20,
                  left: 20
                }}>
                  <XAxis type="number" domain={[0, 5]} ticks={[0, 1, 2, 3, 4, 5]} />
                  <YAxis dataKey="name" type="category" />
                  <Tooltip />
                  <Bar dataKey="score">
                    {[
                      {
                        name: "Pers.",
                        score: [0, parseFloat((locData.totals[dimKey].internal / locData.totals[dimKey].locations_in).toFixed(2))],
                      },
                      {
                        name: "Ouders",
                        score: [0, parseFloat((locData.totals[dimKey].external / locData.totals[dimKey].locations_ex).toFixed(2))]
                      }
                    ].map(bar => <Cell fill={(bar.score[1] > 2.5 ? '#089c19' : '#eb4034')} />)}
                  </Bar>
                  {(Object.values((reportVersion?.extra_data?.results?.dimensions || {})).filter(fff => (fff.name.en || '') !== "Total").map((dimension, i) => <Bar dataKey={dimension.name.en || ''} fill={colours[i]} />))}
                  {!!prevLocData && !!prevLocData.totals[dimKey] && <Bar dataKey="prevScore">
                    {[
                      {
                        name: "Pers.",
                        score: [0, parseFloat((prevLocData.totals[dimKey].internal / prevLocData.totals[dimKey].locations_in).toFixed(2))],
                      },
                      {
                        name: "Ouders",
                        score: [0, parseFloat((prevLocData.totals[dimKey].external / prevLocData.totals[dimKey].locations_ex).toFixed(2))]
                      }
                    ].map(bar => <Cell fill={(bar.score[1] > 2.5 ? '#8bad90' : '#d19792')} />)}
                  </Bar>}

                  <CartesianGrid strokeDasharray="3 3" />
                </BarChart>
              </ResponsiveContainer>}
            </Grid>)}

            <Grid item xs={12}>&nbsp;</Grid>




            {!reportVersion?.report_is_simplified && !!locData && !!prevLocData && !!includePrev && <Grid item xs={12}>
              <Typography sx={{
                fontSize: '0.9rem',
                fontStyle: 'italic',
                color: 'lightgrey',
                textAlign: 'center'
              }}>The Scatterchart will not include previous totals or previous location data.</Typography>
            </Grid>}
            {!reportVersion?.report_is_simplified && !!locData && <Grid item xs={12}>
              <ResponsiveContainer width="100%" height={600}>
                <ScatterChart
                  margin={{
                    top: 20,
                    right: 20,
                    bottom: 20,
                    left: 20
                  }}
                >
                  <CartesianGrid />
                  <ReferenceArea x1={0} x2={2.5} y1={2.5} y2={0} fill="red" fillOpacity={0.3} />
                  <ReferenceArea x1={2.5} x2={5} y1={2.5} y2={5} fill="green" fillOpacity={0.3} />
                  <ReferenceArea x1={0} x2={2.5} y1={5} y2={2.5} fill="orange" fillOpacity={0.2} />
                  <ReferenceArea x1={2.5} x2={5} y1={2.5} y2={0} fill="orange" fillOpacity={0.2} />

                  <XAxis type="number" dataKey="external" label="&nbsp;     &nbsp;      &nbsp;     &nbsp;       &nbsp;   &nbsp;       &nbsp;      &nbsp;      &nbsp;      &nbsp;      Ouders" domain={[0, 5]} ticks={[0, 2.5, 5]} />
                  <YAxis type="number" dataKey="internal" label="Pers.  &nbsp; &nbsp;   &nbsp; &nbsp;   &nbsp;" domain={[0, 5]} ticks={[0, 2.5, 5]} />
                  <Tooltip content={<CustomTooltip />} />

                  <Scatter data={[
                    ...['dim1', 'dim2', 'dim3', 'dim4', 'dim5', 'dim6'].map((dimKey, i) => {return !!locData.totals[dimKey] ? {
                      // @ts-ignore
                      name: `${((reportVersion.extra_data || {})[`dimension${i + 1}`] || {})['nl'][0]}${i+1}`,
                      // @ts-ignore
                      full_name: `${((reportVersion.extra_data || {})[`dimension${i + 1}`] || {})['nl']} (total)`,
                      colour: "#8884d8",
                      internal: parseFloat((locData.totals[dimKey].internal / locData.totals[dimKey].locations_in).toFixed(2)),
                      external: parseFloat((locData.totals[dimKey].external / locData.totals[dimKey].locations_ex).toFixed(2))
                    } : {name: '', colour: '', internal: '', external: ''};}),
                    ...((Object.values((reportVersion?.extra_data?.results?.dimensions || {})).filter(fff => (fff.name.en || '') !== "Total").map((dimension, iii) => {
                      let res:{name: string, colour: string, internal: number, external: number, location: string, full_name: string}[] = [];
                      ['dim1', 'dim2', 'dim3', 'dim4', 'dim5', 'dim6'].forEach((dimKey, i) => {
                        if (!!dimension.totals[dimKey] && (dimension.totals[dimKey].internal + dimension.totals[dimKey].external) > 0) {
                          res.push({
                            // @ts-ignore
                            name: `${((reportVersion.extra_data || {})[`dimension${i + 1}`] || {})['nl'][0]}${i+1}`,
                            // @ts-ignore
                            full_name: ((reportVersion.extra_data || {})[`dimension${i + 1}`] || {})['nl'],
                            colour: colours[iii],
                            internal: dimension.totals[dimKey].internal,
                            external: dimension.totals[dimKey].external,
                            location: dimension.name.en
                          });
                        }
                      });
                      return res;
                    }) || []).reduce((prev, curr) => {
                      return [
                          ...prev,
                          ...curr
                      ];
                    }))
                  ]} fill="#8884d8" shape={(props:any) => {
                    const {cx, cy, fill, name} = props;
                    return (
                      <g>
                        <Dot cx={cx} cy={cy} r={5} fill={props.payload.colour} />
                        <g transform={`translate(${cx},${cy})`}>
                          <text x={10} y={0} dy={4} textAnchor="left">{name}</text>
                        </g>
                      </g>
                    );
                  }} />

                  <ReferenceLine y={0} stroke="#000000" />
                  <ReferenceLine x={0} stroke="#000000" />
                </ScatterChart>
              </ResponsiveContainer>
            </Grid>}
          </>}
        </>)}
      </Grid>

      {!!emailSent && <AlertEmailSent open={emailSent} setOpen={setEmailsent} />}
    </Page>
  );
}
